<template>
    <div class="hitparades">
        <frontinus-data-table
          ref="dtHitparades"
          frontinusTitle="Zoznam hitparád"
          :frontinusItemsLoader="hitparadesLoader()"
          :headers="headers"
          :frontinusActionColumn="{}"
          :frontinusShowSearch="false"
          @click:row="goToDetail($event)"
          @newItem="openFormDialog()"
        ></frontinus-data-table>

        <form-dialog
          v-model="showFormDialog"
          @save="onSubmit()"
        >
          <v-text-field
              v-model.trim="hitparadeModel.name"
              label="Názov"
              :errorMessages="validationErrors.name"
          ></v-text-field>
        </form-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import { HitparadeService } from '@/services/api/hitparade.service'
import FrontinusDataTable from '@/components/FrontinusDataTable.vue'
import FormDialog from '@/components/FormDialog.vue'

export default Vue.extend({
  components: {
    FrontinusDataTable,
    FormDialog
  },
  data () {
    return {
      headers: [
        { text: 'Názov', value: 'name' }
      ],
      showFormDialog: false,
      hitparadeModel: {},
      validationErrors: {}
    }
  },

  methods: {
    hitparadesLoader () {
      return HitparadeService.list
    },
    openFormDialog (model) {
      this.hitparadeModel = model ? { ...model } : {}
      this.showFormDialog = true
    },
    goToDetail (hitparade) {
      this.$router.push({ name: 'hitparades.detail', params: { id: hitparade.id } })
    },
    async onSubmit () {
      if (this.hitparadeModel.id) {
        console.warn('Editing: ', this.hitparadeModel)
      } else {
        try {
          await HitparadeService.create(this.hitparadeModel)
          this.$refs.dtHitparades.reload()
          this.showFormDialog = false
        } catch (e) {
          if (e instanceof ValidationError) {
            this.validationErrors = e.errors
          } else {
            throw e
          }
        }
      }
    }
  }
})
</script>
